import script from "./VideoPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPlay.vue?vue&type=script&setup=true&lang=js"

import "./VideoPlay.vue?vue&type=style&index=0&id=4583d87d&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4583d87d"]])

export default __exports__